module.exports = __webpack_public_path__ + "img/guideTwo.23a89eb6.png";